<template>
  <section class="customcheckerboard-color-control">
    <div ref="colorContainer" class="customcheckerboard-color-control-container">
      <input
        :value="value"
        ref="colorInput"
        class="jscolor customcheckerboard-color-control-input"
      />
    </div>
  </section>
</template>
<script>
import { fabric } from "@vfdp-customs/customs-fabric";
import jscolor from "@/libs/jscolor.js";

export default {
  name: "CheckerboardColorControl",
  props: ['value', 'isMainApp'],
  computed: {
    screenSize() {
      return this.$store.getters["utils/returnScreenSize"];
    },
    safeValue() {
      return this.value && this.value.substr(0, 1) === '#' ? this.value.substr(1) : null;
    }
  },
  watch: {
    safeValue(newValue) {
      if (newValue) {
        this.$refs.colorInput.jscolor.fromString(this.safeValue);
      }
    }
  },
  methods: {
    setColorPickerOptions() {
      const { jscolor } = this.$refs.colorInput;
      const { clientWidth, clientHeight } = this.$refs.colorContainer;
      // Substracting the additional width and
      // height from color calculations to fix its container
      if (this.isMainApp) {
        jscolor.width = clientWidth - 28;
      } else {
        jscolor.width = clientWidth - 56;
      }
      jscolor.height = clientHeight - (this.screenSize.indexOf('mobile') !== -1 ? 20 : 32);
      jscolor.shadow = false;
      jscolor.borderWidth = 0;
      jscolor.borderRadius = 0;
      jscolor.insetWidth = 1;
      jscolor.insetColor = '#ccc';
      jscolor.backgroundColor = "transparent";
      jscolor.value = this.safeValue;
      jscolor.pointerBorderWidth = 1;
      jscolor.padding = 0;
      jscolor.onFineChange = () => {
        const colorValue = jscolor.toString(jscolor.rgb);
        this.$emit('input', `#${colorValue}`);
      };
    }
  },
  mounted() {
    window.jscolor.installByClassName("jscolor");

    setTimeout(() => {
      this.setColorPickerOptions();
      this.$refs.colorInput.jscolor.show();
    }, 650);
  },
  beforeDestroy() {
    this.$refs.colorInput.jscolor.hide();
  }
};
</script>
